import { css } from "@emotion/react";
type Props = {
  color?: string;
  height?: string;
};
export const IdLogo = (props: Props) => {
  return (
    <svg
      css={
        props.height
          ? css({
              height: props.height,
            })
          : height
      }
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 223.43 27"
    >
      <g>
        <g>
          <rect
            x="31.49"
            y="8.53"
            width="4.71"
            height="17.82"
            rx=".2"
            ry=".2"
          />
          <path d="M156.48,7.9c-5.82,0-9.89,3.91-9.89,9.51,0,5.77,3.88,9.51,9.89,9.51,5.92,0,9.89-3.82,9.89-9.51,0-5.77-3.88-9.51-9.89-9.51Zm0,14.91c-3.63,0-5.63-1.92-5.63-5.41,0-3.34,2.16-5.41,5.63-5.41,3.63,0,5.63,1.92,5.63,5.41s-2.05,5.41-5.63,5.41Z" />
          <path d="M61.12,8.52h-5.75c-.13,0-.26,.05-.37,.13l-8.7,6.89V.2c0-.11-.09-.2-.2-.2h-4.35c-.11,0-.2,.09-.2,.2V26.16c0,.11,.09,.2,.2,.2h4.35c.11,0,.2-.09,.2-.2v-5.33l2.45-2,7.2,7.35c.11,.11,.27,.18,.43,.18h4.8c.17,0,.26-.21,.15-.34l-9.27-9.88,9.2-7.27c.15-.12,.06-.35-.12-.35Z" />
          <path d="M89.02,3.2h-3.99c-.11,0-.2,.08-.2,.19q0,.6,0,13.96v.1c0,6.69,3.24,9.54,10.63,9.54,.9,0,2.42-.04,3.26-.13,.1-.01,.17-.1,.17-.2v-3.83c0-.12-.11-.21-.23-.2-.79,.11-2.25,.16-3.21,.16-4.68,0-6.24-.77-6.24-5.35v-.1c0-.42,0-4.88,0-4.88h9.48c.11,0,.2-.09,.2-.2v-3.57c0-.11-.09-.2-.2-.2h-9.48s0-4.17,0-5.11c0-.11-.09-.19-.2-.19Z" />
          <path d="M71.9,7.96c-1.66,0-3.26,.26-4.73,.7-1.55,.47-2.22,1.02-2.41,1.2-.05,.05-.09,.12-.09,.19v3.22c0,.16,.17,.25,.3,.17,.46-.29,1.43-.97,3.01-1.39,1.11-.29,2.21-.49,3.35-.49,1.66,0,3.09,.35,3.93,1.04,.84,.7,1.27,1.58,1.27,2.88v.36l-5.39-.08c-2.9,0-5.03,.5-6.38,1.51-1.35,1.01-1.86,2.46-1.86,4.13,0,1.07,.22,2.11,.84,2.95,.62,.85,1.41,1.42,2.54,1.9,1.14,.47,2.46,.71,3.97,.71,1.98,0,4.14,.04,5.8-.08,3.62-.27,5.19-.98,5.19-5.48v-5.56c0-2.64-1.04-4.53-2.62-5.84-1.58-1.31-3.77-2.05-6.74-2.05Zm4.63,12.64c0,2.49-.75,3.21-3.08,3.21-.14,0-1.76,0-1.91,0-1.21,0-2.44-.23-3.13-.7-.68-.46-1.02-1.09-1.02-1.88,0-1.65,1.36-2.34,4.09-2.34l5.05,.08v1.62Z" />
          <path d="M111.35,7.96c-1.66,0-3.26,.26-4.73,.7-1.55,.47-2.22,1.02-2.41,1.2-.05,.05-.09,.12-.09,.19v3.22c0,.16,.17,.25,.3,.17,.46-.29,1.43-.97,3.01-1.39,1.11-.29,2.21-.49,3.35-.49,1.66,0,3.09,.35,3.93,1.04,.84,.7,1.27,1.58,1.27,2.88v.36l-5.39-.08c-2.9,0-5.03,.5-6.38,1.51-1.35,1.01-1.86,2.46-1.86,4.13,0,1.07,.22,2.11,.84,2.95,.62,.85,1.41,1.42,2.54,1.9,1.14,.47,2.46,.71,3.97,.71,1.98,0,4.14,.04,5.8-.08,3.62-.27,5.19-.98,5.19-5.48v-5.56c0-2.64-1.04-4.53-2.62-5.84-1.58-1.31-3.77-2.05-6.74-2.05Zm4.63,12.64c0,2.49-.75,3.21-3.08,3.21-.14,0-1.76,0-1.91,0-1.21,0-2.44-.23-3.13-.7-.68-.46-1.02-1.09-1.02-1.88,0-1.65,1.36-2.34,4.09-2.34l5.05,.08v1.62Z" />
          <path d="M13.23,11.73L6.05,1.85C5.52,1.13,4.48,0,2.98,0h-.19C1.25,0,0,1.25,0,2.8V26.16c0,.11,.09,.2,.2,.2H4.49c.11,0,.2-.09,.2-.2V7.88l8.05,10.94c.24,.32,.72,.32,.96,0l7.76-10.82V26.16c0,.11,.09,.2,.2,.2h4.29c.11,0,.2-.09,.2-.2V2.8c0-1.54-1.25-2.8-2.8-2.8h-.34c-1.4,0-2.21,.94-2.74,1.67l-7.04,10.06Z" />
          <circle cx="33.84" cy="2.85" r="2.85" />
        </g>
        <path
          css={
            props.color
              ? css({
                  fill: props.color,
                })
              : color
          }
          d="M174.86,0h-2.81c-.87,0-1.72,.31-2.39,.87l-6.08,5.18c-.71,.6-.29,1.75,.64,1.75h2.81c.87,0,1.72-.31,2.39-.87l6.08-5.18c.71-.6,.29-1.75-.64-1.75Z"
        />
        <path d="M143.52,26.36h-3.93c-.11,0-.2-.09-.2-.2v-8.57c0-3.93-.83-5.79-5.55-5.79s-5.55,1.87-5.55,5.79v8.57c0,.11-.09,.2-.2,.2h-3.93c-.11,0-.2-.09-.2-.2v-8.57c0-2.5,0-10.13,9.88-10.13s9.88,7.62,9.88,10.13v8.57c0,.11-.09,.2-.2,.2Z" />
      </g>
      <g>
        <rect x="190.36" y=".91" width="4.59" height="25.18" />
        <path d="M222.46,8.5c-.64-1.53-1.57-2.87-2.75-3.99-1.18-1.12-2.61-2.01-4.24-2.64-1.63-.63-3.45-.95-5.4-.95h-9.42V26.09h9.42c1.95,0,3.77-.33,5.41-.97,1.63-.64,3.06-1.54,4.24-2.66,1.18-1.12,2.11-2.47,2.75-4.01,.64-1.54,.97-3.22,.97-4.98s-.33-3.43-.97-4.96Zm-3.86,5.03c0,1.22-.21,2.35-.62,3.37-.41,1.02-.99,1.91-1.72,2.64-.73,.74-1.64,1.32-2.69,1.73-1.05,.41-2.24,.62-3.53,.62h-4.81V5.11h4.81c1.29,0,2.47,.21,3.53,.64,1.05,.42,1.96,1.01,2.69,1.76s1.31,1.64,1.72,2.66c.41,1.02,.62,2.15,.62,3.37Z" />
      </g>
    </svg>
  );
};
const color = css({
  fill: "#00c1ff",
});
const height = css({
  height: "16px",
});
